import { Dispatch } from "redux";
import { formatVerificationTransactionDetails } from "@formatters/verification-transaction-details/verification-transaction-details-formatter";
import { FormattedVerificationTransactionDetails } from "@idw-types/data/verification-transaction-details";
import { setVerificationTransactionDetailsData, setVerificationTransactionDetailsDataLoading } from "@redux/actions/verification-transaction-details-actions";
import { resources } from "@constants/hardcoded-strings";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { getVerificationTransactionDetailsRequest } from "@requests/reports/get-verification-transaction-details";
import { AxnRelyingParty, AxnTransactionType, AxnSelectedServiceOfferingSO, AxnAttributeType, AxnCountry } from "@idw-types/data/reference-data/axn";
import { Assertion } from "@idw-types/data/reference-data/generic";

export const getVerificationTransactionDetailsDataReduxRequest = (dispatch: Dispatch) => async (
    transactionId: string,
    relyingParties: Array<AxnRelyingParty>,
    transactionTypes: Array<AxnTransactionType>,
    axnSelectedServiceOfferingSOs: Array<AxnSelectedServiceOfferingSO>,
    attributeTypes: Array<AxnAttributeType>,
    assertions: Array<Assertion>,
    axnCountries: Array<AxnCountry>
): Promise<FormattedVerificationTransactionDetails> => {
    dispatch(setVerificationTransactionDetailsDataLoading(true));
    const { data, error, body } = await getVerificationTransactionDetailsRequest(
        transactionId,
        Intl.DateTimeFormat().resolvedOptions().timeZone
    );
    if (data) {
        const formattedVerificationTransactionDetails = formatVerificationTransactionDetails(
            data,
            relyingParties,
            transactionTypes,
            axnSelectedServiceOfferingSOs,
            attributeTypes,
            assertions,
            axnCountries
        );
        dispatch(setVerificationTransactionDetailsData(formattedVerificationTransactionDetails));
        return formattedVerificationTransactionDetails;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getVerificationTransactionDetails.error.title,
                resources.requests.getVerificationTransactionDetails.error.message,
                null,
                null,
                body
            );
        }
        dispatch(setVerificationTransactionDetailsDataLoading(false));
    }

    return null;
};